import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { getText, isRtl, type Lang } from './translations';
export function CompletionSlide({
  onFinish,
  lang = 'en' as Lang
}: {
  onFinish: () => void;
  lang?: Lang;
}) {
  const rtl = isRtl(lang);
  return <div className="flex flex-col h-full px-6 py-12 relative z-10 bg-white justify-center items-center" dir={rtl ? 'rtl' : 'ltr'} data-id="element-105">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="w-full max-w-sm text-center flex flex-col items-center" data-id="element-106">
        <div className="w-24 h-24 rounded-full overflow-hidden mb-6 border-4 border-white shadow-md relative" data-id="element-107">
          <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=1000&auto=format&fit=crop" alt="Doctor saying thank you" className="w-full h-full object-cover object-top" data-id="element-108" />
        </div>

        <h1 className="text-3xl font-semibold text-slate-900 leading-tight mb-4" data-id="element-109">
          {getText('completionTitle', lang)}
        </h1>

        <p className="text-base text-stone-600 leading-relaxed mb-6" data-id="element-110">
          {getText('completionBody', lang)}
        </p>

        <button onClick={onFinish} className="w-full py-4 bg-nhs-blue text-white rounded-xl font-semibold text-lg flex items-center justify-center hover:bg-nhs-darkblue transition-colors shadow-md shadow-nhs-blue/20 active:scale-[0.98]" data-id="element-111">
          {getText('finish', lang)}
        </button>
      </motion.div>
    </div>;
}